import {render} from 'react-dom';

import '@/styles';

// App 组件必现使用懒加载的方式，否则国际化渲染可能会出错。
// 以汉字 "产品名称" 为例，在编译阶段会被替换为 i18n('产品名称')
// const productName = '产品名称' 会被编译为 const productName = i18n('产品名称')
// 非懒加载的方式，定义在常量之类文件的这种代码会直接执行。此时国际化语料包还没完成加载，所以会导致出错。
import App from '@/components/App/Lazy';

import {initConsoleConfig, initConsoleFramework, initDayJs} from './common';


const h5RouteMap: Record<string, string> = {
    '/finance/pay': '/finance/h5/pay',
};

export const redirectH5IfNeed = () => {
    const isMobileBrowser = () => {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    };

    if (isMobileBrowser() && h5RouteMap[location.pathname]) {
        window.location.href = `${h5RouteMap[location.pathname]}${location.search}`;
        return true;
    }
};


(() => {
    if (redirectH5IfNeed()) {
        return;
    }

    initDayJs();

    initConsoleConfig();

    initConsoleFramework().then(() => {
        const root = document.getElementById('main');
        render(<App />, root);
    });
})();
